import Api from './ApiRequest';

export default {
    getAll: () => Api.get('/cent/notifications',null),
    markAsRead: (id) => Api.put('/cent/notification/' + id + '/markasread')
};